<template>
  <div>
    <div class="spcore-box" :style="`background-color: ${background || '#f5fbfb'}`">
      <div class="v-card__title pb-3 pl-4">
        <div class="hvh-analysis-visualization__title">
          <h2 class="hvh-h6">{{ title }}</h2>
        </div>
        <div class="spacer"></div>
      </div>
      <div class="v-card__text px-0">
        <div class="hvh-analysis-visualization__chart">
          <BarchartFilter
            class="px-5 pb-4"
            :style="`background-color: ${background || '#f5fbfb'}`"
            :nameField="nameField"
            :valueField="valueFieldPercentage"
            :data="chartData"
            :options="chartOptions"
            :isFiltering="false"
            :displayedBarChartData="10"
            height="288px"
            @checked-changed="emitChange"
            @chart-created="$emit('refresh-data', $event)"
            @refresh-data="$emit('refresh-data', $event)"
          />
          <div class="pr-4" style="text-align: end" v-if="clickText">
            <span class="clickable">{{ clickText }} ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { customNumberFormat, propToFnc } from '../../../libraries/common';
import BarchartFilter from '../../analysis/filters/BarchartFilter.vue';
export default {
  components: { BarchartFilter },
  props: ['title', 'data', 'valueField', 'nameField', 'background', 'clickText'],
  data() {
    return {
      chartOptions: {
        backgroundColor: this.background || '#f5fbfb',
        yAxis:
        {
          axisLabel: {
            formatter: value => `${value}%`,
          }
        },
        tooltip: {
          formatter: (params) => {
            var marker = '<dt style="width:10px;height:10px;display:inline-block;margin-right:5px;">' +
              '<svg viewBox="0 0 12 12"><path fill="' + params.color + '" d="M0 0h12v12H0z"></path></svg>' +
              '</dt>';

            return '<div style="max-width:400px;white-space:pre-wrap;">' +
              params.name + '<br>' +
              marker + ' ' + customNumberFormat(params.data.data[this.valueField]) + '<br>' +
              '<div>';
          }
        }
      },
    }
  },
  computed: {
    valueFieldPercentage() {
      return `${this.valueField}Percentage`;
    },
    chartData() {
      return this.data
        .map(f => ({
          ...f,
          [this.valueFieldPercentage]: f[this.valueField] / this.totalCount * 100,
        }));
    },
    valueFnc() {
      return propToFnc(this.valueField);
    },
    totalCount() {
      return (this.data || [])
        .sum(this.valueFnc);
    },
  },
  methods: {
    emitChange(event, data) {
      this.$emit('checked-changed', event, data);
    },
  },
}
</script>
